<template>
  <span class="badge">{{ formatNumber(props.value) }}</span>
</template>

<script setup lang="ts">
const props = defineProps({ value: { type: Number, required: true } })
const formatNumber = new Intl.NumberFormat('en-US').format
</script>
